import axios from "axios";
import { OrderLogApi } from "../api"
import { User } from "../classes"
export class OrderLog {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      if(value.className && value.className == '_User'){
        this[key] = new User(value);
      }else{
        this[key] = value;
      }
    }
  }
  static async getOrderLogs(orderId) {
    const { data } = await OrderLogApi.getOrderLogs(orderId);
    return data.result.map((item) => new OrderLog(item)).sort((a, b) => { return new Date(b.createdAt) - new Date(a.createdAt) })
  }
}